





























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import FormattedNumber from '@/components/FormattedNumber.vue'

@Component<TsNpsCounts>({
    components: {FormattedNumber}
})
export default class TsNpsCounts extends Vue {
    @Prop({ type: Number, required: true }) public countPositive!: number
    @Prop({ type: Number, required: true }) public countNegative!: number
    @Prop({type: Number, required: true}) public maxResponded!: number
    @Prop({type: Boolean, default: false}) public showBg!: number

    public get countWidthPositive() {
        return (this.countPositive / this.maxResponded) * 90 + '%'
    }
    public get countWidthNegative() {
        return (this.countNegative / this.maxResponded) * 90 + '%'
    }

}
